// test1943
(1943 && 0);
